import ApiService from './ApiService.js';

const ContentService = {
    get: (options, service = ApiService()) => service.get(`/Content?lotId=${options.lotId}`, true)
        .then(response => response)
        .catch(error => error.response),
};

export default ContentService;
